import Required from "./Required";

type props = {
  type: string;
  label?: string;
  labelClass?: string;
  inputClass?: string;
  widthClass?: string;
  sizeClass?: string;
  mginClass?: string;
  holderClass?: string;
  isRequired?: boolean;
  maxLength?: number;
  pattern?: string;
  formprops?: any;
  displayErr?: boolean;
  accept?: string;
  diabled?: boolean;
  min?: string;
  onInput?: React.FormEventHandler<HTMLInputElement> | undefined;
};

const InputProfile = ({
  type,
  label,
  labelClass,
  inputClass,
  widthClass,
  sizeClass,
  mginClass,
  holderClass,
  isRequired,
  pattern,
  formprops,
  displayErr,
  maxLength,
  accept,
  diabled,
  min,
  onInput,
}: props) => {
  return (
    <>
      <div className={`text-base || ${labelClass} font-lato`}>
        <div>
          {isRequired && <Required />}
          {label}
        </div>
        <input
          type={type}
          maxLength={maxLength}
          className={`w-full h-10 p-2 border-gray-400 border rounded-md mt-2 font-lato ${inputClass} ${widthClass} ${mginClass} `}
          placeholder={holderClass}
          required
          pattern={pattern}
          accept={accept}
          {...formprops}
          disabled={diabled ? diabled : false}
          min={min}
          onInput={onInput}
        />
        {displayErr && <p className={`text-red-500`}>This field is Required</p>}
      </div>
    </>
  );
};

export default InputProfile;
